import Vue from 'vue'
import Vuex from 'vuex'
import warehouse from './modules/warehouse';
import sales from './modules/sales';
import authentication from './modules/authentication';
import purchase from './modules/purchase';
import administration from './modules/administration';
import accounting from './modules/accounting';
import common from './modules/common';
import corporate from './modules/corporate';
import stockJournal from './modules/stockJournal';
// import snackBar from './modules/common/snackBar';
import sms from './modules/sms';
//import journalEntry from './modules/accounting/journalEntry';
import stock from './modules/stock';
import scheduling from './modules/scheduling'
import ui from './modules/ui';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    warehouse,
    sales,
    authentication,
    purchase,
    administration,
    accounting,
    common,
    sms,
    corporate,
    stockJournal,
    stock,
    scheduling,
    ui
  }
})
